// extracted by mini-css-extract-plugin
export default {"root":"ResourceNotFound_root__JjktY"};